import React, { useState } from "react";
import Img from "../../../molecules/Img";
import ladyone from "../../../../assets/pics/infinitbanner/ladyonetwo.webp";
import ladytwo from "../../../../assets/pics/infinitbanner/taheya_karoka.jpg";
import outline from "../../../../assets/pics/outline.jpg";
import square from "../../../../assets/pics/square.jpg";
import mantwo from "../../../../assets/pics/infinitbanner/mantwo.png";
import manthree from "../../../../assets/pics/infinitbanner/manthree.png";
import manfour from "../../../../assets/pics/infinitbanner/omaralshreif.webp";
import manfive from "../../../../assets/pics/infinitbanner/nagebmahfoz.jpg";
import "./styles.css";

import Title from "../../../atoms/Title";
import Button from "./../../../atoms/Button/Button";
import { colors } from "../../../../assets/colors/colors";

import { PiCaretLeftBold } from "react-icons/pi";
import { PiCaretRightBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const characters = [
  {
    id: 0,
    content:
      "تمت إضافة الفنان حلمي بكر علي قائمة عاش هنا حيث أنه يعد من الشخصيات التي تسلط الضوء عليها في المجال الفني حيث انه حصل علي العديد من الجوائز",
    image: outline,
  },
  {
    id: 1,
    content:
      "أُضيفت الفنانة سعاد حسني إلى قائمة عاش هنا تقديراً لإسهاماتها الكبيرة في السينما المصرية، حيث اشتهرت بلقب سندريلا الشاشة العربية.",
    image: ladyone, // Replace with actual image if available
  },
  {
    id: 2,
    content:
      "الفنان عمر الشريف، المعروف بأدواره في السينما العالمية، أُدرج ضمن قائمة عاش هنا تكريماً لإسهاماته الفنية على المستوى العالمي.",
    image: manfour, // Replace with actual image if available
  },
  {
    id: 3,
    content:
      "أُدرجت الأديبة نجيب محفوظ في قائمة عاش هنا كونه أول عربي يحصل على جائزة نوبل في الأدب، مؤثراً بأعماله في الأدب العربي والعالمي.",
    image: manfive, // Replace with actual image if available
  },
  {
    id: 4,
    content:
      "أُضيفت الراقصة والفنانة تحية كاريوكا إلى قائمة عاش هنا لكونها من أبرز الشخصيات في الفن المصري، بأعمالها المتنوعة في الرقص والتمثيل.",
    image: ladytwo, // Replace with actual image if available
  },
];

export default function Addedrecently({ data }) {
  // console.log("dattttttttttta",data);

  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const goToNext = () => setCurrentIndex((currentIndex + 1) % data?.length);
  const goToPrevious = () =>
    setCurrentIndex((currentIndex - 1 + data?.length) % data?.length);

  // console.log("currentIndex",currentIndex)

  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const current = data?.[currentIndex];
  const characterName = isArabic
    ? current?.characterName
    : current?.characterNameE;
  const bio = isArabic ? current?.bio : current?.bioE;

  const handleCharClick = () => {
    console.log("beo");
    navigate(`about.aspx?id=${current?.characterId ?? null}`);
  };
  return (
    <div className="h-[290px] md:h-[480px] md:py-[10px] mt-[10px] overflow-hidden">
      <div className="h-14 md:h-1/6 flex justify-start ms-[25px]">
        <Title primary>{t("home.recent.title")}</Title>
      </div>

      <div
        className="flex justify-between items-center h-4/6 md:h-4/6"
        style={{ backgroundColor: colors[1] }}
      >
        <div className="flex flex-col justify-end items-start w-2/3 px-[10px] md:ps-[20px] ">
          <div className="text-amber mb-2 font-cairo-bold text-xs md:text-xl lg:text-2xl leading-6 md:leading-10 line-clamp-2 text-start ">
            {characterName || t("common.noData")}
          </div>
          <div className=" font-cairo-bold text-xs md:text-xl lg:text-2xl leading-6 md:leading-10 line-clamp-2 text-start overflow-hidden">
            {bio || t("common.noData")}
          </div>

          <div className="mt-[10px] ps-[30px]">
            <Button secondary rounded onClick={handleCharClick}>
              {t("common.more")}
            </Button>
          </div>
        </div>

        <div className="flex justify-center items-center relative me-[6px] md:mx-[20px]">
          <div>
            <Button arrow_left onClick={goToNext}>
              {<PiCaretLeftBold style={{ color: colors[1] }} />}
            </Button>
          </div>
          <div className="mx-[35px] md:mx-[50px]">
            <Img
              square_with_outline
              src={current?.characterImages}
              alt={characterName}
            />
          </div>
          <div>
            <Button arrow_right onClick={goToPrevious}>
              {<PiCaretRightBold style={{ color: colors[1] }} />}
            </Button>
          </div>
        </div>
      </div>
      {/* <Img rectangular src={ladyone} alt={"beobeo"}/> */}
      {/* <Img square_with_outline src={outline} alt={"beobeo"}/> */}
      {/* <Img square src={square} alt={"beobeo"}/> */}
      {/* <Img bigsquare src={square} alt={"beobeo"}/> */}
    </div>
  );
}
